import EnhancedAreaAutoComplete from "./AreaAutoComplete";

export default EnhancedAreaAutoComplete;
